<section class="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
  <div class="mb-6 flex flex-wrap items-center justify-between gap-3">
    <div>
      <h1 class="text-3xl font-semibold text-slate-900">Empresas</h1>
      <p class="text-sm text-slate-500">
        Gestiona y controla todas tus empresas clientes
      </p>
    </div>
    <button
      class="inline-flex items-center gap-2 rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white transition hover:bg-slate-700"
      (click)="openModal(crear)"
    >
      <i class="bi bi-plus-circle"></i>Nueva Empresa
    </button>
  </div>

  <div
    class="mb-6 rounded-2xl border border-slate-200 bg-white p-5 text-center shadow-sm"
  >
    <div class="mb-1 text-sky-600">
      <i class="bi bi-buildings text-3xl"></i>
    </div>
    <h6 class="text-xs uppercase tracking-wide text-slate-500">Total</h6>
    <h3 class="text-3xl font-semibold text-slate-900">
      {{ getEmpresasTotal() }}
    </h3>
  </div>

  <div
    class="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
  >
    <div class="border-b border-slate-200 px-4 py-4">
      <div class="flex flex-wrap items-center justify-between gap-3">
        <h5 class="text-base font-semibold text-slate-900">
          Lista de Empresas
        </h5>
        <div class="flex flex-wrap items-center gap-2">
          <input
            type="text"
            class="w-64 rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-sky-500 focus:ring-2 focus:ring-sky-200"
            placeholder="Buscar por RUC o empresa..."
            [(ngModel)]="searchTerm"
            (input)="onSearchChange()"
          />
          <select
            class="rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-sky-500 focus:ring-2 focus:ring-sky-200"
            [(ngModel)]="selectedFilter"
            (change)="filterEmpresas()"
          >
            <option value="Todas">Todas</option>
            <option value="Activa">Activas</option>
            <option value="Inactiva">Inactivas</option>
          </select>
          <button
            class="rounded-lg border border-slate-300 bg-white px-3 py-2 text-slate-700 transition hover:bg-slate-50 disabled:opacity-70"
            (click)="refreshData()"
            [disabled]="loading"
          >
            <i class="bi bi-arrow-clockwise" [class.spin]="loading"></i>
          </button>
        </div>
      </div>
    </div>

    <div>
      @if (loading) {
        <div class="flex items-center justify-center gap-2 py-12">
          <div
            class="h-5 w-5 animate-spin rounded-full border-2 border-slate-300 border-t-sky-600"
          ></div>
          <span class="text-sm text-slate-500">Cargando empresas...</span>
        </div>
      }

      @if (error && !loading) {
        <div
          class="m-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700"
          role="alert"
        >
          <i class="bi bi-exclamation-triangle mr-2"></i>{{ error }}
          <button
            class="ml-2 rounded border border-red-300 px-2 py-1 text-xs transition hover:bg-red-100"
            (click)="refreshData()"
          >
            Reintentar
          </button>
        </div>
      }

      @if (!loading && !error) {
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-slate-200 text-sm">
            <thead class="bg-slate-50">
              <tr>
                <th class="px-4 py-3 text-left font-semibold text-slate-600">
                  RUC
                </th>
                <th class="px-4 py-3 text-left font-semibold text-slate-600">
                  Nombre
                </th>
                <th class="px-4 py-3 text-left font-semibold text-slate-600">
                  Correo
                </th>
                <th class="px-4 py-3 text-left font-semibold text-slate-600">
                  Vencimiento
                </th>
                <th class="px-4 py-3 text-left font-semibold text-slate-600">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-200 bg-white">
              @for (empresa of paginatedEmpresas; track $index) {
                <tr class="hover:bg-slate-50">
                  <td class="px-4 py-4 font-medium text-slate-900">
                    {{ empresa.ruc }}
                  </td>
                  <td class="px-4 py-4 font-medium text-slate-900">
                    {{ empresa.nombre }}
                  </td>
                  <td class="px-4 py-4 text-slate-700">{{ empresa.email }}</td>
                  <td class="px-4 py-4 text-slate-700">
                    {{ $safeNavigationMigration(empresa.licencia?.fecha_fin) | date: "dd/MM/yyyy" }}
                  </td>
                  <td class="px-4 py-4">
                    <div class="flex flex-wrap gap-2">
                      <button
                        class="rounded-full border border-slate-300 px-3 py-1.5 text-xs text-slate-700 transition hover:bg-slate-100"
                        title="Gestionar sedes"
                        (click)="irASedes(empresa)"
                      >
                        <i class="bi bi-shop"></i>
                      </button>
                      <button
                        class="rounded-full border border-slate-300 px-3 py-1.5 text-xs text-slate-700 transition hover:bg-slate-100"
                        title="Gestionar usuarios"
                        (click)="irAUsuarios(empresa)"
                      >
                        <i class="bi bi-people"></i>
                      </button>
                      <button
                        class="rounded-full border border-amber-300 px-3 py-1.5 text-xs text-amber-700 transition hover:bg-amber-50"
                        title="Reconsultar SUNAT pendientes"
                        (click)="openModal(reconsultaSunat, empresa, { size: 'md', keyboard: false })"
                      >
                        <i class="bi bi-cloud-arrow-down"></i>
                      </button>
                      <button
                        class="rounded-full border border-sky-300 px-3 py-1.5 text-xs text-sky-700 transition hover:bg-sky-50"
                        title="Editar empresa"
                        (click)="openModal(editar, empresa)"
                      >
                        <i class="bi bi-pencil"></i>
                      </button>
                      <button
                        class="rounded-full border border-red-300 px-3 py-1.5 text-xs text-red-700 transition hover:bg-red-50"
                        title="Eliminar empresa"
                        (click)="openModal(eliminar, empresa)"
                      >
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              }
              @if (paginatedEmpresas.length === 0 && !loading) {
                <tr>
                  <td
                    colspan="8"
                    class="px-4 py-12 text-center text-sm text-slate-500"
                  >
                    <i class="bi bi-building mb-2 block text-3xl"></i>
                    <div>No se encontraron empresas</div>
                    <small>Agrega tu primera empresa para comenzar</small>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>

    <div
      class="flex flex-wrap items-center justify-between gap-3 border-t border-slate-200 px-4 py-3"
    >
      <span class="text-xs text-slate-500">
        @if (filteredEmpresas.length > 0) {
          Mostrando {{ getStartIndex() }}-{{ getEndIndex() }} de
          {{ filteredEmpresas.length }} empresas
        } @else {
          No se encontraron empresas
        }
      </span>
      @if (totalPages > 1) {
        <nav aria-label="Navegación de páginas" class="flex items-center gap-1">
          <button
            class="rounded-lg border border-slate-300 px-2 py-1 text-xs text-slate-700 disabled:cursor-not-allowed disabled:opacity-50"
            (click)="prevPage()"
            [disabled]="currentPage === 1"
          >
            Anterior
          </button>
          @for (page of getPageNumbers(); track page) {
            <button
              class="rounded-lg border px-2 py-1 text-xs"
              [class.border-sky-500]="page === currentPage"
              [class.bg-sky-500]="page === currentPage"
              [class.text-white]="page === currentPage"
              [class.border-slate-300]="page !== currentPage"
              [class.text-slate-700]="page !== currentPage"
              (click)="goToPage(page)"
            >
              {{ page }}
            </button>
          }
          <button
            class="rounded-lg border border-slate-300 px-2 py-1 text-xs text-slate-700 disabled:cursor-not-allowed disabled:opacity-50"
            (click)="nextPage()"
            [disabled]="currentPage === totalPages"
          >
            Siguiente
          </button>
        </nav>
      }
    </div>
  </div>
</section>

<ng-template #crear let-modal>
  <app-modal-crear
    [modal]="modal"
    (createSuccess)="onCreateSuccess()"
    (createError)="onCreateError($event)"
  />
</ng-template>

<ng-template #editar let-modal>
  <app-modal-editar
    [modal]="modal"
    [empresa]="empresaSeleccionada"
    (editSuccess)="onEditSuccess()"
    (editError)="onEditError($event)"
  />
</ng-template>

<ng-template #eliminar let-modal>
  <app-modal-eliminar
    [modal]="modal"
    [empresa]="empresaSeleccionada"
    (deleteSuccess)="onDeleteSuccess()"
    (deleteError)="onDeleteError($event)"
  >
  </app-modal-eliminar>
</ng-template>

<ng-template #reconsultaSunat let-modal>
  <app-modal-sunat
    [modal]="modal"
    [empresa]="empresaSeleccionada"
    [empresas]="empresas"
    (reconsultaExitosa)="onReconsultaSunatExitosa($event)"
    (reconsultaError)="onReconsultaSunatError($event)"
  />
</ng-template>

<app-toast aria-live="polite" aria-atomic="true"></app-toast>
